import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { findAllSites, setSelectedSite } from 'src/redux/actions/sites';
import {
  addChecklistFromLibrary,
  completeChecklistRun,
  deleteChecklistTemplate,
  findChecklistAssignees,
  findChecklistHistory,
  findChecklistLibrary,
  findChecklistRun,
  findChecklistRuns,
  findChecklistTemplates,
  reassignChecklistRun,
  saveChecklistResponse,
  saveChecklistResponses,
  saveChecklistTemplate,
  startChecklistRun
} from 'src/redux/actions/checklists';
import { getUser } from 'src/redux/selectors';
import { getSitesAvailableToUser } from 'src/utils/siteAccess';

class Checklists extends Component {
  componentDidMount() {
    // Sites may not be loaded yet on a fresh login.
    if (!this.props.sites.length) {
      Promise.resolve(this.props.findAllSites()).catch(() => {});
    }
  }

  render() {
    const { Layout, ...rest } = this.props;
    return <Layout {...rest} />;
  }
}

const mapStateToProps = state => ({
  user: getUser(state) || {},
  sites: getSitesAvailableToUser(state.sites.allSites || [], getUser(state) || {}),
  selectedSite: state.sites.selectedSite || null,
  templates: state.checklists.templates || [],
  library: state.checklists.library || [],
  runs: state.checklists.runs || [],
  history: state.checklists.history || [],
  assignees: state.checklists.assignees || [],
  serverTime: state.checklists.serverTime,
  fetchedAt: state.checklists.fetchedAt
});

const mapDispatchToProps = {
  findAllSites,
  setSelectedSite,
  findChecklistLibrary,
  findChecklistTemplates,
  saveChecklistTemplate,
  deleteChecklistTemplate,
  addChecklistFromLibrary,
  findChecklistRuns,
  findChecklistRun,
  startChecklistRun,
  saveChecklistResponse,
  saveChecklistResponses,
  completeChecklistRun,
  findChecklistHistory,
  findChecklistAssignees,
  reassignChecklistRun
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Checklists));
